import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../services/auth.service';
import { LoadingController, ToastController } from '@ionic/angular';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private authService: AuthService,
        private toastController: ToastController,
        private loadingController: LoadingController
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((err: HttpErrorResponse) => {
                const status = err?.status;
                const isApi = request.url.startsWith(environment.apiURI);
                const isLoginAttempt =
                    request.method === 'POST' &&
                    request.url.includes('/auth/login');

                if ((status === 401 || status === 419) && isApi) {
                    if (isLoginAttempt) {
                        this.presentServerMessages(err);
                    } else {
                        this.authService.logout();
                    }
                    return throwError(err);
                }

                if (status !== 401 && status !== 419 && status !== 402) {
                    this.presentServerMessages(err);
                }

                return throwError(err);
            })
        );
    }

    private presentServerMessages(err: HttpErrorResponse): void {
        const body = err?.error;

        if (body?.errors) {
            this.showErrors(body.errors);
            return;
        }
        if (Array.isArray(body?.message)) {
            this.showErrors(body.message);
            return;
        }
        if (typeof body?.message === 'string' && body.message) {
            this.presentToast('top', body.message);
            return;
        }
        if (err?.message) {
            this.presentToast('top', err.message);
        }
    }

    private showErrors(errors: any): void {
        if (errors == null) {
            return;
        }
        if (typeof errors === 'string') {
            this.presentToast('top', errors);
            return;
        }
        if (Array.isArray(errors)) {
            this.presentToast('top', errors.join('\n'));
            return;
        }
        if (typeof errors !== 'object') {
            return;
        }
        let errorMessage = '';
        Object.entries(errors).forEach(([, v]) => {
            const part = Array.isArray(v) ? v.join(', ') : String(v);
            errorMessage += part + '\n';
        });
        if (errorMessage.trim()) {
            this.presentToast('top', errorMessage.trim());
        }
    }

    async presentToast(position: 'top' | 'middle' | 'bottom', message: string) {
        const toast = await this.toastController.create({
            message,
            duration: 2000,
            position,
            color: 'danger',
        });
        try {
            await this.loadingController.dismiss();
        } catch {
            /* ignore */
        }
        await toast.present();
    }
}
